import { createSlice } from '@reduxjs/toolkit';
import { Permissions } from 'rbac/roles';
import { AuthReduxState } from 'redux/selectors/auth';

type ExtendedAuthReduxState = AuthReduxState & {
	permissions: Permissions[];
};

const initialState: ExtendedAuthReduxState = {
	hasuraKey: '',
	tipoUsuario: 'noUser',
	uid: '',
	user_id: '',
	nombre: '',
	displayName: '',
	authorized: false,
	permissions: []
};

const authSlice = createSlice({
	name: 'auth',
	initialState,
	reducers: {
		authenticated: (state, action) => {
			return { ...state, ...action.payload };
		},
		logout: () => {
			return initialState;
		},
		setTipoUsuario: (state, action) => {
			return { ...state, tipoUsuario: action.payload };
		}
	}
});

export const { authenticated, logout, setTipoUsuario } = authSlice.actions;
export default authSlice.reducer;
